<template>
  <default-layout>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-form @submit.prevent="resetPassword" ref="resetForm" id="loginForm">
          <v-card class="elevation-1" :loading="loading">
            <v-toolbar flat>
              <v-toolbar-title>Reset password</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-card-text>
              <v-text-field
                id="current-password"
                label="Current Password"
                name="current-password"
                prepend-icon="mdi-lock"
                type="password"
                v-model="currentPassword"
                :rules="currentPasswordRules"
              />

              <v-text-field
                id="new-password"
                label="New Password"
                name="new-password"
                prepend-icon="mdi-lock-reset"
                type="password"
                v-model="newPassword"
                :rules="newPasswordRules"
              />

              <p class="error--text text-right">{{ error }}</p>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn type="submit" color="primary">Reset</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>

    <v-snackbar v-model="showSnack" top :timeout="5000" color="info">{{
      snackMsg
    }}</v-snackbar>
  </default-layout>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "PasswordReset",

  data() {
    return {
      currentPassword: "",
      newPassword: "",
      error: null,
      snackMsg: null,
      showSnack: null,
      loading: false,

      // RULES
      newPasswordRules: [
        (v) => !!v || "New password is required",
        (v) => v.length > 6 || "Must be at least 6 characters long",
      ],
      currentPasswordRules: [
        (v) => !!v || "Current password is required",
        (v) => v.length > 6 || "Must be at least 6 characters long",
      ],
    };
  },

  mounted() {
    console.log("ROUTE", this.$route);
  },

  methods: {
    ...mapActions({
      cognitoResetPassword: "cognito/cognitoResetPassword",
      resetSymfonyPassword: "symfonyUser/resetSymfonyPassword",
    }),
    async resetPassword() {
      this.loading = true;
      const valid = this.$refs.resetForm.validate();
      if (!valid) {
        this.loading = false;
        return;
      }

      try {
        await this.cognitoResetPassword({
          currentPassword: this.currentPassword,
          newPassword: this.newPassword,
        });

        await this.resetSymfonyPassword({ password: this.newPassword });

        this.snackMsg = "Password reset successfully";
        this.showSnack = true;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.error("PASSWORD RESET ERROR", e);
        if (e.code && e.code === "NotAuthorizedException") {
          this.error = "Incorrect password.";
        } else if (e && e.message) {
          console.log("Setting error message", e.message);
          this.error = e.message;
        }
      }
    },
  },
};
</script>

<style scoped></style>
